// @file Reads the role-change lock's refusal out of a failed fetch
import { ApiErrorCode, HttpCode } from '@@/enums'

// The seat-change guard's 422 carries the sentence the user should read; anything else is still a bug.
const paymentMethodRequiredTitle = (e?: { status?: number; message?: string } | null): string | null => {
  if (e?.status !== HttpCode.UnprocessableEntity) return null
  try {
    const error = JSON.parse(e?.message ?? '').errors?.[0]
    return error?.code === ApiErrorCode.PAYMENT_METHOD_REQUIRED && typeof error.title === 'string' ? error.title : null
  } catch {
    return null
  }
}

export { paymentMethodRequiredTitle }
